import * as yup from "yup";

/**
 * LoginSchema for Validation
 * @date 15/02/2023 - 18:59:45
 *
 * @type {*}
 */
export const LoginSchema = yup.object().shape({
  email: yup.string().trim().required().email(),
  password: yup.string().required(),
});

/**
 * ResetPasswordSchema for validation
 * @type {*}
 */
export const ResetPasswordSchema = yup.object().shape({
  password: yup.string().required().min(8).max(16).label("Password"),
  confirmPassword: yup
    .string()
    .required()
    .oneOf([yup.ref("password"), ""], "Passwords must match")
    .label("Confirm password"),
});

const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
/**
 * ForgotPasswordSchema for validation
 * @date 15/02/2023 - 18:59:45
 *
 * @type {*}
 */
export const ForgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .required()
    .email()
    .matches(emailRegExp, "Email must be a valid email"),
});

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
/**
 * SignUpStepOneSchema for validation
 * @date 15/02/2023 - 18:59:45
 *
 * @type {*}
 */
export const SignUpSchema = yup.object().shape({
  first_name: yup.string().required().max(20).label("First name"),
  last_name: yup.string().required().max(50).label("Last name"),
  email: yup
    .string()
    .required()
    .email("Email must be a valid email")
    .max(100)
    .label("Email")
    .matches(emailRegExp, "Email must be a valid email"),
  company_name: yup.string().required().max(255).label("Company name"),
  phone: yup
    .string()
    .required()
    .label("Phone number")
    .min(10)
    .max(10)
    .matches(phoneRegExp, "Phone number is not valid"),
  cell_number: yup
    .string()
    .label("Cell number")
    .matches(phoneRegExp, "Cell number is not valid"),
  address: yup.string().required().min(1).max(255).label("Address"),
  city: yup.string().required().min(1).max(50).label("City"),
  state: yup.string().required().max(100).label("State"),
  zip_code: yup.string().required().min(1).max(15).label("Zip"),
  password: yup.string().required().min(8).max(16).label("Password"),
  confirm_password: yup
    .string()
    .required()
    .oneOf([yup.ref("password"), ""], "Passwords must match")
    .label("Confirm password"),

  billing_contact_name: yup
    .string()
    .required()
    .min(1)
    .max(30)
    .label("Billing contact name"),
  billing_contact_email: yup
    .string()
    .required()
    .email()
    .max(100)
    .label("Billing contact email")
    .matches(emailRegExp, "Billing contact email must be a valid email"),
  billing_cell_number: yup
    .string()
    .label("Cell number")
    .matches(phoneRegExp, "Cell number is not valid"),
  billing_address: yup.string().required().min(1).max(255).label("Address"),
  billing_city: yup.string().required().min(1).max(50).label("City"),
  billing_state: yup.string().required().max(20).label("State"),
  billing_zip: yup.string().required().min(1).max(15).label("Zip"),

  yard_same_billing: yup.boolean(),
  yard_city: yup.string().required().min(1).max(50).label("City"),
  yard_address: yup.string().required().min(1).max(255).label("Address"),
  yard_state: yup.string().required().max(20).label("State"),
  yard_zip: yup.string().required().min(1).max(15).label("Zip"),

  decal_contact: yup.string().required().min(1).max(30).label("Decal contact"),
  decal_email: yup
    .string()
    .required()
    .email()
    .max(255)
    .label("Decal contact email")
    .matches(emailRegExp, "Decal contact email must be a valid email"),
  decal_cell_number: yup
    .string()
    .label("Cell number")
    .matches(phoneRegExp, "Cell number is not valid"),
  decal_address: yup.string().required().min(1).max(255).label("Address"),
  decal_city: yup.string().required().min(1).max(50).label("City"),
  decal_state: yup.string().max(20).label("State"),
  decal_zip: yup.string().required().min(1).max(15).label("Zip"),
});
